<template>
  <div class="page_container goodsManagePage">
    <div class="breadcrumb flex-rowl">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/manage' }"
          >SKU管理</el-breadcrumb-item
        >
        <el-breadcrumb-item :to="{ path: '/commondityIndex/cManageIndex' }"
          >商品管理</el-breadcrumb-item
        >
        <el-breadcrumb-item>商品生产组码管理</el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <div class="main_container">
      <div class="operation_wrap flex-between">
        <div class="select_add flex-rowl"></div>
        <div class="filter flex-rowr">
          <div class="download_btn"><a :href="'https://shop.winksshowp.com/service/groupmadown.aspx?maid='+id">下载</a></div>
        </div>
      </div>
      <div
        class="list_wrap"
        v-loading="loading"
        element-loading-text="加载中"
        element-loading-spinner="el-icon-loading"
        element-loading-background="rgba(0, 0, 0, 0.4)"
      >
        <template v-if="dataItem.length > 0">
          <div class="item_wrap" v-for="item in dataItem" :key="item.id">
            <div class="item_main_wrap flex-between">
              <div class="content_wrap flex-between">
                <div class="pic_box">
                  <el-image :src="item.ercode" fit="contain">
                    <div slot="error" class="image-slot flex-rowc">
                      <i class="iconfont icon-zanwutupian1"></i>
                    </div>
                  </el-image>
                </div>
                <div class="intro_box flex-rowl">
                  <div class="block">
                    <p>
                      生产批次：<span>{{ detail.productno }}</span>
                    </p>
                    <p>
                      货码：<span>{{ item.biancode }}</span>
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </template>

        <el-empty
          description="暂无数据"
          v-if="!loading && dataItem.length == 0"
        ></el-empty>
      </div>
    </div>
  </div>
</template>

<script>
import { encryptstringview } from "../../../api/api";
import { getShopProductionCodeDetail } from "../../../api/shop";
import { mapState } from "vuex";
export default {
  name: "cProductionCodeDetail",
  data() {
    return {
      loading: false,
      id: "",
      detail: "",
      dataItem: "",
    };
  },
  filters: {
    // 时间格式化
    formatDate(date) {
      if (!date) return "";
      if (date.indexOf("T") != -1) {
        let dateSplit = date.split("T");
        let dataTime =
          dateSplit[1].indexOf(".") != -1
            ? dateSplit[1].split(".")[0]
            : dateSplit[1];
        return dateSplit[0] + " " + dataTime; // 这里可以根据需要使用不同的日期格式化选项
      } else {
        return date;
      }
    },
  },
  computed: {
    ...mapState(["OPENID"]),
  },
  created() {
    let { routerList, OPENID } = this.$store.state;
    let { name } = this.$route;
    // 判断是有有参数需要解密 this.$route中的name和state.routerList对象
    if (name in routerList) {
      if (routerList[name].encryptstring == "") return;
      this.encryptstringview(routerList[name].encryptstring, OPENID);
    }
  },
  methods: {
    // 通过解密获取参数
    async encryptstringview(encryptstring, openid) {
      let res = await encryptstringview({ openid, encryptstring });
      if (res.result) {
        let { id } = JSON.parse(res.jsondata);
        this.id = id;
        this.getShopProductionCodeDetail(id);
      } else {
        this.$router.back();
      }
    },

    getShopProductionCodeDetail(id) {
      this.loading = true;
      getShopProductionCodeDetail({ id }).then((res) => {
        this.detail = res;
        this.dataItem = res.detail;
        this.loading = false;
      });
    },

  },
};
</script>
<style lang="less" scoped>
.goodsManagePage {
  .list_wrap {
    height: 57vh;
    .item_main_wrap {
      align-items: center;
      .icon-zanwutupian1 {
        font-size: 40px;
      }
      .pic_box {
        width: 80px;
        height: 80px;
      }
      .btn_group {
        .editBtn {
          &:last-child {
            margin-top: 20px;
          }
        }
      }
    }
  }
  .download_btn {
    background: #6e5c86;
    // padding: 5px 20px;
    display: inline-block;
    color: #fff;
    font-size: 16px;
    cursor: pointer;
    width: 100px;
    height: 30px;
    text-align: center;
    line-height: 30px;
    a {
        display: block;
        color: #fff;
    }
  }
}
</style>